/**
 * entraAppsApi.ts - AutoDoc "Applications Entra ID".
 * Configuration des App Registrations lue en direct via Microsoft Graph
 * (identité, credentials, permissions API, redirect URIs, propriétaires).
 */
import { apiFetch } from './apiClient';

export interface EntraAppCredential { type: string; name?: string; endDateTime?: string; daysToExpiry?: number | null; status?: string; }
export interface EntraAppPermission { api: string; type: string; permission: string; }

export interface EntraApp {
  displayName:     string;
  appId:           string;
  objectId:        string;
  createdDateTime?: string;
  signInAudience?:  string;
  publisherDomain?: string;
  notes?:          string | null;
  identifierUris:  string[];
  redirectUris:    string[];
  owners:          string[];
  credentials:     EntraAppCredential[];
  permissions:     EntraAppPermission[];
  exposedRoles:    number;
  exposedScopes:   number;
  secretsCount:    number;
  certsCount:      number;
  expiredCreds:    number;
}

export interface EntraAppsFacts {
  apps: EntraApp[];
  summary?: { total: number; withExpiredCreds: number; totalExpired: number; withSecrets: number; withCerts: number };
}

export interface EntraAppsFactsResponse {
  success:   boolean;
  tenantId?: string;
  runAt?:    string;
  facts?:    EntraAppsFacts;
  warnings?: { fact: string; code?: number; error?: string }[];
  error?:    string;
  hint?:     string;
}

export const entraAppsApi = {
  get: () => apiFetch<EntraAppsFactsResponse>('/entra-apps-facts'),
};
